<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
import {getMe} from '@/api/login.js'
import {viewCountAdd} from '@/api/index/index.js'
export default {
  name: 'App',
  created(){
    document.title="泉州市科技馆"
    this.viewCountAdd()
  },
  data(){
     return{
     }
  },
  methods:{
    viewCountAdd(){
      viewCountAdd().then(res=>{
        if(res.data.code==0){

        }
      })
    }
  },
  mounted(){
    // getMe().then(res=>{
    //   if(res.data.code=='0'){
    //   }else if(res.data.code=='403'){
    //     localStorage.removeItem('userInfo')
    //     localStorage.removeItem('userAllInfo')
    //   }else{
    //     localStorage.removeItem('userInfo')
    //     localStorage.removeItem('userAllInfo')
    //   }
    // })
  }
}
</script>

<style>
 #app{
    overflow-x: hidden;
    width: 100vw!important;
 }
</style>
<!-- https://www.csdn.net/tags/NtTacgxsOTk3NzktYmxvZwO0O0OO0O0O.html -->



// WEBPACK FOOTER //
// src/App.vue